import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PartnersComponent } from './partners/partners.component';
import { PartnersDetailsComponent } from './partners-details/partners-details.component';
import { AuthGuardService } from './services/guard/auth-guard.service';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { AboutComponent } from './about/about.component';
import { FaqComponent } from './faq/faq.component';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { KycComponent } from './kyc/kyc.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';


const routes: Routes = [
    {
       path: '',
       component: PartnersComponent,
       canActivate: [AuthGuardService]
    },

    { 
      path: 'home',
      component: HomeComponent,
      canActivate: [AuthGuardService]
    },

    {
      path: 'login', 
      component: LoginComponent
    },
    
    {
      path: 'forget-password', 
      component: ForgetPasswordComponent
    },

    { 
      path: 'terms-conditions',
      component: TermsConditionsComponent
    },

    { 
      path: 'about',
      component: AboutComponent
    },

    { 
      path: 'faq',
      component: FaqComponent
    },

    {
      path: 'partners',
      component: PartnersComponent,
      canActivate: [AuthGuardService],
      data: { breadcrumb: 'partners' }
    },

    {
      path: 'partner-details/:id/:catId',
      component: PartnersDetailsComponent,
      canActivate: [AuthGuardService],
      data: { breadcrumb: 'partner details' }
    },

   {
      path: 'transactions',
      component: TransactionsComponent,
      canActivate: [AuthGuardService],
      data: { breadcrumb: 'transactions' }
    },
    {
      path: 'updateprofile',
      component: UpdateProfileComponent,
      canActivate: [AuthGuardService],
      // data: { breadcrumb: 'transactions' }
    },
    {
      path: 'kyc',
      component: KycComponent,
    }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
